import { render, staticRenderFns } from "./PriceRangeTableItemContainer.vue?vue&type=template&id=0bca3288&scoped=true"
import script from "./PriceRangeTableItemContainer.vue?vue&type=script&lang=js"
export * from "./PriceRangeTableItemContainer.vue?vue&type=script&lang=js"
import style0 from "./PriceRangeTableItemContainer.vue?vue&type=style&index=0&id=0bca3288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca3288",
  null
  
)

export default component.exports